import { IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

interface ModalCloseButtonProps {
  isSaving: boolean;
  handleOnClickClose: () => void;
}

const ModalCloseButton = ({ isSaving, handleOnClickClose }: ModalCloseButtonProps) => {
  return (
    <IconButton
      aria-label="Cerrar"
      onClick={handleOnClickClose}
      disabled={isSaving}
      size="small"
      sx={{
        position: "absolute",
        right: 8,
        top: "50%",
        transform: "translateY(-50%)",
        color: "#002652",
      }}
    >
      <CloseIcon />
    </IconButton>
  );
};

export default ModalCloseButton;
